import { render, staticRenderFns } from "./AdvertHeader.vue?vue&type=template&id=5c8a73ee&"
import script from "./AdvertHeader.vue?vue&type=script&lang=js&"
export * from "./AdvertHeader.vue?vue&type=script&lang=js&"
import style0 from "./AdvertHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardSubtitle,VIcon})
